import { Injectable } from '@angular/core';
import { OperatorPaymentService } from './operator-payment.service';
import { HttpService } from '../httpService/http.service';
import { Observable } from 'rxjs';
import { MoreRecords, NewPaymentsSummary, Payment } from '../../../model/payment';
import { PaymentSummary, PaymentCount } from '../../../model/payment_summary';
import { PieChartData, GraphAndBarChartData } from '../../../model/chart-data';

@Injectable({
  providedIn: 'root'
})
export class HttpOperatorPaymentService extends OperatorPaymentService {

  constructor(
    private httpService: HttpService
  ) {
    super();
  }

  getAccountManagerPaymentsByPage(pageNo: number, pageSize: number, useDepositDate?: boolean, fromDate?: string, toDate?: string): Observable<Payment[]> {
    const url = `/getAccountManagerPaymentsByPage?pageNo=${pageNo}&pageSize=${pageSize}&useDepositDate=${!!useDepositDate}${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}`;
    return this.httpService.get(url, true);
  }

  getAccountManagerPayments(): Observable<Payment[]> {
    const url = `/getAccountManagerPayments`;
    return this.httpService.get(url, true);
  }

  getPayment(paymentId: number): Observable<Payment> {
    const url = `/getPayment/${paymentId}`;
    return this.httpService.get(url, true);
  }

  getAccountPaymentSummaryByPeriodByProduct(accountId: number, fromDate: string, toDate: string, period: string, propertyId: number, productId: number, breakdown: string, useDepositDate?: boolean): Observable<GraphAndBarChartData[]> {
    const url = `/getAccountPaymentSummaryByPeriodByProduct?accountId=${accountId}&fromDate=${fromDate}&toDate=${toDate}&period=${period}&propertyId=${propertyId}&productId=${productId}&breakdown=${breakdown}&useDepositDate=${!!useDepositDate}`;
    return this.httpService.get(url, true);
  }

  getAccountPaymentsByPage(accountId: number, pageNo: number, pageSize: number, useDepositDate?: boolean, fromDate?: string, toDate?: string): Observable<Payment[]> {
    const url = `/getAccountPaymentsByPage?accountId=${accountId}&pageNo=${pageNo}&pageSize=${pageSize}&useDepositDate=${!!useDepositDate}${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}`;
    return this.httpService.get(url, true);
  }
  getAccountPaymentSummaryByProperty(accountId: number, fromDate: string, toDate: string, propertyId: number, productId: number, useDepositDate?: boolean): Observable<PieChartData[]> {
    const url = `/getAccountPaymentSummaryByProperty?accountId=${accountId}&fromDate=${fromDate}&toDate=${toDate}&propertyId=${propertyId}&productId=${productId}&useDepositDate=${!!useDepositDate}`;
    return this.httpService.get(url, true);
  }
  getAccountPaymentSummaryByProduct(accountId: number, fromDate: string, toDate: string, propertyId: number, productId: number, useDepositDate?: boolean): Observable<PieChartData[]> {
    const url = `/getAccountPaymentSummaryByProduct?accountId=${accountId}&fromDate=${fromDate}&toDate=${toDate}&propertyId=${propertyId}&productId=${productId}&useDepositDate=${!!useDepositDate}`;
    return this.httpService.get(url, true);
  }
  getAccountPaymentSummaryByPeriod(accountId: number, fromDate: string, toDate: string, propertyId: number, productId: number, breakdoen: string, useDepositDate?: boolean): Observable<PaymentSummary> {
    const url = `/getAccountPaymentSummaryByPeriod?accountId=${accountId}&fromDate=${fromDate}&toDate=${toDate}&propertyId=${propertyId}&productId=${productId}&breakdown=${breakdoen}&useDepositDate=${!!useDepositDate}`;
    return this.httpService.get(url, true);
  }
  getAccountPaymnetSummaryByPeriodByProperty(accountId: number, fromDate: string, toDate: string, period: string, propertyId: number, productId: number, breakdown: string, useDepositDate?: boolean): Observable<GraphAndBarChartData[]> {
    const url = `/getAccountPaymentSummaryByPeriodByProperty?accountId=${accountId}&fromDate=${fromDate}&toDate=${toDate}&period=${period}&propertyId=${propertyId}&productId=${productId}&breakdown=${breakdown}&useDepositDate=${!!useDepositDate}`;
    return this.httpService.get(url, true);
  }

  getAccountManagerPaymentSummaryByProperty(fromDate: string, toDate: string, propertyId: number, productId: number, useDepositDate?: boolean): Observable<PieChartData[]> {
    const url = `/getAccountManagerPaymentSummaryByProperty?fromDate=${fromDate}&toDate=${toDate}&propertyId=${propertyId}&productId=${productId}&useDepositDate=${!!useDepositDate}`;
    return this.httpService.get(url, true);
  }

  getAccountManagerPaymentSummaryByProduct(fromDate: string, toDate: string, propertyId: number, productId: number, useDepositDate?: boolean): Observable<PieChartData[]> {
    const url = `/getAccountManagerPaymentSummaryByProduct?fromDate=${fromDate}&toDate=${toDate}&propertyId=${propertyId}&productId=${productId}&useDepositDate=${!!useDepositDate}`;
    return this.httpService.get(url, true);
  }

  getAccountManagerPaymentSummaryByPeriod(fromDate: string, toDate: string, propertyId: number, productId: number, breakdown: string, useDepositDate?: boolean): Observable<PaymentSummary> {
    const url = `/getAccountManagerPaymentSummaryByPeriod?fromDate=${fromDate}&toDate=${toDate}&propertyId=${propertyId}&productId=${productId}&breakdown=${breakdown}&useDepositDate=${!!useDepositDate}`;
    return this.httpService.get(url, true);
  }

  getAccountManagerPaymentSummaryByPeriodByProperty(fromDate: string, toDate: string, period: string, propertyId: number, productId: number, breakdown: string, useDepositDate?: boolean): Observable<GraphAndBarChartData[]> {
    const url = `/getAccountManagerPaymentSummaryByPeriodByProperty?fromDate=${fromDate}&toDate=${toDate}&period=${period}&propertyId=${propertyId}&productId=${productId}&breakdown=${breakdown}&useDepositDate=${!!useDepositDate}`;
    return this.httpService.get(url, true);
  }

  getAccountManagerPaymentSummaryByPeriodByProduct(fromDate: string, toDate: string, period: string, propertyId: number, productId: number, breakdown: string, useDepositDate?: boolean): Observable<GraphAndBarChartData[]> {
    const url = `/getAccountManagerPaymentSummaryByPeriodByProduct?fromDate=${fromDate}&toDate=${toDate}&period=${period}&propertyId=${propertyId}&productId=${productId}&breakdown=${breakdown}&useDepositDate=${!!useDepositDate}`;
    return this.httpService.get(url, true);
  }

  getAccountManagerPaymentsMoreRecords(pageNo: number, pageSize: number, useDepositDate?: boolean, fromDate?: string, toDate?: string): Observable<MoreRecords> {
    return this.httpService.get(`/getAccountManagerPaymentsMoreRecords?pageNo=${pageNo}&pageSize=${pageSize}&useDepositDate=${!!useDepositDate}${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}`, true);
  }

  getAccountManagerPaymentsByOperatorMoreRecords(operatorId: number, pageNo: number, pageSize: number, useDepositDate?: boolean, fromDate?: string, toDate?: string): Observable<MoreRecords> {
    return this.httpService.get(`/getAccountManagerPaymentsByOperatorMoreRecords?operatorId=${operatorId}&pageNo=${pageNo}&pageSize=${pageSize}&useDepositDate=${!!useDepositDate}${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}`, true);
  }

  getAccountManagerPaymentsByOperatorByPage(operatorId: number, pageNo: number, pageSize: number, useDepositDate?: boolean, fromDate?: string, toDate?: string): Observable<Payment[]> {
    return this.httpService.get(`/getAccountManagerPaymentsByOperatorByPage?operatorId=${operatorId}&pageNo=${pageNo}&pageSize=${pageSize}&useDepositDate=${!!useDepositDate}${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}`, true);
  }

  getAccountPaymentsByOperatorMoreRecords(accountId: number, operatorId: number, pageNo: number, pageSize: number, useDepositDate?: boolean, fromDate?: string, toDate?: string): Observable<MoreRecords> {
    return this.httpService.get(`/getAccountPaymentsByOperatorMoreRecords?accountId=${accountId}&operatorId=${operatorId}&pageNo=${pageNo}&pageSize=${pageSize}&useDepositDate=${!!useDepositDate}${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}`, true);
  }

  getAccountPaymentsByOperatorByPage(accountId: number, operatorId: number, pageNo: number, pageSize: number, useDepositDate?: boolean, fromDate?: string, toDate?: string): Observable<Payment[]> {
    return this.httpService.get(`/getAccountPaymentsByOperatorByPage?accountId=${accountId}&operatorId=${operatorId}&pageNo=${pageNo}&pageSize=${pageSize}&useDepositDate=${!!useDepositDate}${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}`, true);
  }

  getAccountPaymentsMoreRecords(accountId: number, pageNo: number, pageSize: number, useDepositDate?: boolean, fromDate?: string, toDate?: string): Observable<MoreRecords> {
    return this.httpService.get(`/getAccountPaymentsMoreRecords?accountId=${accountId}&pageNo=${pageNo}&pageSize=${pageSize}&useDepositDate=${!!useDepositDate}${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}`, true);
  }

  getAccountManagerSummaryPayment(noDays: number): Observable<NewPaymentsSummary> {
    return this.httpService.get(`/getAccountManagerSummaryPayment?noDays=${noDays}`, true);
  }

  getAccountPendingPaymentCount(accountId: number): Observable<PaymentCount> {
    const url = `/getAccountPendingPaymentCount?accountId=${accountId}`;
    return this.httpService.get(url, true);
  }

  getAccountManagerPendingPaymentCount(): Observable<PaymentCount> {
    const url = `/getAccountManagerPendingPaymentCount`;
    return this.httpService.get(url, true);
  }
}
